var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1E6EFA",
    d: "M12.493 15.98H2.46C1.1 15.98 0 14.896 0 13.56c0-1.338 1.1-2.423 2.459-2.423l5.685-.003c.936 0 1.8.491 2.267 1.29l2.082 3.557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF3C5A",
    d: "M1.863 9.77 6.88 1.212C7.559.053 9.062-.344 10.238.325a2.403 2.403 0 0 1 .901 3.309L8.3 8.485a2.622 2.622 0 0 1-2.267 1.289l-4.17-.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC5CE",
    d: "m12.653 3.808 5.017 8.56a2.402 2.402 0 0 1-.9 3.307c-1.176.669-2.68.272-3.36-.886l-2.845-4.848a2.542 2.542 0 0 1 0-2.578l2.088-3.555Z"
  }))));
};
export default SvgLogo;